import React from 'react';
import { Link } from 'react-router-dom'

export default ({label, icon, to, children}) => (
  <Link className="link " to={to}>
    { icon ? icon : null }
    { label ? <span>{label}</span> : null }
    { children ? <span>{children}</span> : null }
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/Navigation/MenuLink.jsx